<div class="container-fuid bg-white default-boxrounded">
  <form [formGroup]="form">
    <div class="p-4 mb-3">
      <div class="row mb-3">
        <div class="col-7">
          @if (newRequestMode) {
            <h2 translate="Modals.NewRequestPicker.NewRequestTitle"></h2>
          }
          @if (!newRequestMode) {
            <h2 translate="Modals.NewRequestPicker.EditRequestTitle"></h2>
          }
        </div>
      </div>
      <div class="mb-3">
        <label for="workgroupSelector" class="form-label text-truncate d-block" translate="Modals.NewRequestPicker.RequestType">
        </label>
        <div ngbDropdown class="dropdown w-100" ngDefaultControl formControlName="requestWorkflowControl" name="workflow"
          id="workgroup">
          <button class="btn btn-sm dropdown-toggle form-control text-truncate default" type="button"
            id="dropdownMenu" ngbDropdownToggle [disabled]="disableWorkflowDropdown" [attr.data-testid]="'requestWorkflowDropdownToggle'">
            {{ selectedRequestTypeName | translate}}
            <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100" data-testid="requestWorkflowDropdownMenu">
            @if (workflowsOfTypeGeneric.length > 0 ) {
              <button class="bold dropdown-header" ngbDropdownItem value="{{null}}" translate="WorkFlowRequests.NewRequestTypeHeaders.Generic"
              ></button>
            }
            @for (genericWorkflow of workflowsOfTypeGeneric; track genericWorkflow) {
              <button ngbDropdownItem
                class="ms-2"
                value="{{genericWorkflow.id}}" [translate]="genericWorkflow.translationKey"
                [attr.data-testid]="genericWorkflow.bySettingName"
                (click)="changeWorkflowType(genericWorkflow)" >
              </button>
            }

            @if (allowAllRequestsTypes) {
              <!-- General workflow -->
              @if (workflowsOfTypeTax.length > 0 ) {
                <button class="mt-2 bold dropdown-header" ngbDropdownItem value="{{null}}" translate="WorkFlowRequests.NewRequestTypeHeaders.Tax"
                ></button>
              }
              @for (taxWorkflow of workflowsOfTypeTax; track taxWorkflow) {
                <button ngbDropdownItem
                  class="ms-2"
                  value="{{taxWorkflow.id}}" [translate]="taxWorkflow.translationKey"
                  [attr.data-testid]="taxWorkflow.bySettingName"
                  (click)="changeWorkflowType(taxWorkflow)" >
                </button>
              }
              <!-- CoC workflow -->
              @if (workflowsOfTypeChamberOfCommerce.length > 0 ) {
                <button class="mt-2 bold dropdown-header" ngbDropdownItem value="{{null}}" translate="WorkFlowRequests.NewRequestTypeHeaders.CoC"
                  >
                </button>
              }
              @for (cocWorkflow of workflowsOfTypeChamberOfCommerce; track cocWorkflow) {
                <button ngbDropdownItem
                  class="ms-2"
                  value="{{cocWorkflow.id}}" [translate]="cocWorkflow.translationKey"
                  [attr.data-testid]="cocWorkflow.bySettingName"
                  (click)="changeWorkflowType(cocWorkflow)" >
                </button>
              }
              <!-- SBR workflow -->
              @if (workflowsOfTypeSbrNexus.length > 0 ) {
                <button class="mt-2 bold dropdown-header" ngbDropdownItem value="{{null}}" translate="WorkFlowRequests.NewRequestTypeHeaders.Sbr"
                  >
                </button>
              }
              @for (sbrNexusWorkflow of workflowsOfTypeSbrNexus; track sbrNexusWorkflow) {
                <button ngbDropdownItem
                  class="ms-2"
                  value="{{sbrNexusWorkflow.id}}" [translate]="sbrNexusWorkflow.translationKey"
                  [attr.data-testid]="sbrNexusWorkflow.bySettingName"
                  (click)="changeWorkflowType(sbrNexusWorkflow)" >
                </button>
              }
              <!-- WWFT workflow -->
              @if (workflowsOfTypeWwft.length > 0 ) {
                <button class="mt-2 bold dropdown-header" ngbDropdownItem value="{{null}}" translate="WorkFlowRequests.NewRequestTypeHeaders.Wwft"
                  >
                </button>
              }
              @for (wwftWorkflow of workflowsOfTypeWwft; track wwftWorkflow) {
                <button ngbDropdownItem
                  class="ms-2"
                  value="{{wwftWorkflow.id}}" [translate]="wwftWorkflow.translationKey"
                  [attr.data-testid]="wwftWorkflow.bySettingName"
                  (click)="changeWorkflowType(wwftWorkflow)" >
                </button>
              }
            }
          </div>
        </div>
        <app-formcontrol-error-messages [forControl]="requestWorkflowControl"></app-formcontrol-error-messages>
      </div>
      <div class="mb-3">
        <label for="requestTitle" class="form-label" translate="Modals.NewRequestPicker.RequestTitle">
          <span class="ms-1 fst-italic fw-normal" translate="Modals.NewRequestPicker.Optional"></span>
        </label>
        <input type="text" id="requestName" [placeholder]="newRequestTypeName" formControlName="requestRequestNameControl" class="form-control" data-testid="requestNameInput" />
      </div>
      @if (selectableWorkgroups.length > 0) {
        <div class="mb-3">
          <label for="workgroup" class="form-label" translate="Modals.NewRequestPicker.Workgroup"></label>
          <div ngbDropdown class="dropdown" ngDefaultControl formControlName="requestWorkgroupControl" name="workgroup"
            id="workgroup">
            <button class="btn btn-sm dropdown-toggle form-control text-truncate default w-100" type="button"
              id="dropdownMenu" ngbDropdownToggle>
              {{ selectedWorkgroupName }}
              <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="w-100">
              <button ngbDropdownItem value="{{null}}" (click)="changeWorkgroup(null)"
              translate="Request.RequestTitle.Noworkgroup"></button>
              @for (workgroupModel of selectableWorkgroups; track workgroupModel) {
                <button ngbDropdownItem
                  value="{{workgroupModel.guid}}"
                (click)="changeWorkgroup(workgroupModel)">{{workgroupModel.name}}</button>
              }
            </div>
          </div>
          <app-formcontrol-error-messages [forControl]="requestWorkgroupControl"></app-formcontrol-error-messages>
        </div>
        @if (getMaxClearanceLevelForWorkgroup > 1) {
          <div class="mb-3">
            <label for="clearanceLevel" class="form-label" translate="Modals.NewRequestPicker.ClearanceLevel"></label>
            <div ngbDropdown class="dropdown" ngDefaultControl formControlName="clearancelevel"
              name="clearancelevel" id="clearancelevel">
              <button class="btn btn-sm dropdown-toggle form-control text-truncate default" type="button"
                id="dropdownMenu" ngbDropdownToggle>
                {{ selectedClearanceLevel }}
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                @for (clearancelevelValue of allowedClearanceLevels; track clearancelevelValue) {
                  @if (clearancelevelValue <= getMaxClearanceLevelForWorkgroup) {
                    <button ngbDropdownItem value="{{clearancelevelValue}}"
                      (click)="changeClearanceLevel(clearancelevelValue)">
                      {{clearancelevelValue}}
                    </button>
                  }
                }
              </div>
            </div>
            <app-formcontrol-error-messages [forControl]="requestClearanceControl"></app-formcontrol-error-messages>
          </div>
        }
      }

      <!-- Display Auto export editor -->
      @if (showAutoExport && hasEnabledPlugins) {
        <div class="mb-3 row-cols-md-12">
          <label class="form-label text-truncate d-block" translate="Request.RequestTitle.AutoExportTitle">
            <app-info-button labelName="Request.RequestTitle.AutoExportTooltip"></app-info-button>
          </label>
          <div class="input-group">
            <button type="button" class="btn btn-sm"
              [ngClass]="hasCloudItemSet ? 'btn-danger' : 'btn-primary'"
              (click)="hasCloudItemSet ? resetAutoExport() : openFolderSelection()">
              @if (!hasCloudItemSet) {
                <span
                translate="Button.SelectPath"></span>
              }
              @if (hasCloudItemSet) {
                <span
                translate="Button.ClearPath"></span>
              }
            </button>
            <input type="text" class="form-control" [value]="selectedfolderPath" readonly>
          </div>
        </div>
      }
      <div class="mb-5 w-100">
        <button type="button" class="btn btn-sm float-start btn-outline-primary" (click)="closeModal()" translate="Button.Back" data-testid="newRequestPickerBackButton"></button>
        @if (newRequestMode) {
          <button type="submit" class="btn btn-sm float-end btn-primary" (click)="saveRequest()" [disabled]="createClicked" translate="Button.Create" data-testid="createRequestButton"></button>
        }
        @if (!newRequestMode) {
          <button type="submit" class="btn btn-sm float-end btn-primary" (click)="updateRequest()" [disabled]="saveClicked" translate="Button.Save" data-testid="saveRequestButton"></button>
        }
      </div>
    </div>
  </form>
</div>